import React from 'react';
import { Link } from 'react-router-dom';

/* --- Icônes SVG intégrées (Composants légers) --- */
const IconStrategy = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path>
    <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path>
  </svg>
); // Icône "Livre Ouvert / Plan"

const IconDev = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="16 18 22 12 16 6"></polyline>
    <polyline points="8 6 2 12 8 18"></polyline>
  </svg>
); // Icône "Code / Balises"

const IconSecurity = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
  </svg>
); // Icône "Bouclier / Sécurité"


export default function Services() {
  
  const services = [
    { 
      id: 1,
      title: "Conseil & Stratégie", 
      text: "La technologie sans vision n'est rien. Nous auditons vos processus pour bâtir une feuille de route digitale claire, rentable et adaptée à votre croissance.",
      icon: <IconStrategy />, // Appel du composant icône
      color: "var(--secondary)" // Jaune Moutarde
    },
    { 
      id: 2,
      title: "Développement Sur-Mesure", 
      text: "Sites vitrines, E-commerce ou SaaS complexes. Nous concevons des plateformes robustes, rapides et centrées sur l'expérience utilisateur.",
      icon: <IconDev />, 
      color: "var(--primary)" // Rose Corail
    },
    { 
      id: 3,
      title: "Maintenance & Évolution", 
      text: "Un produit digital doit vivre. Nous assurons la sécurité, les mises à jour et l'ajout de nouvelles fonctionnalités pour que vous restiez compétitif.",
      icon: <IconSecurity />, 
      color: "var(--accent)" // Vert Menthe
    }
  ];

  return (
    <div className="container section">
      
      {/* --- En-tête --- */}
      <div style={{ textAlign: 'center', marginBottom: '70px' }}>
        <h1 style={{ marginBottom: '15px' }}>Nos Expertises</h1>
        <p style={{ maxWidth: '700px', margin: '0 auto', color: 'var(--text-grey)', fontSize: '1.1rem' }}>
          Transformer les défis complexes en solutions numériques simples et performantes, grâce à un accompagnement 360°.
        </p>
      </div>

      {/* --- Grille --- */}
      <div className="grid-container">
        {services.map((service) => (
          <div 
            key={service.id} 
            className="card" 
            style={{ 
              textAlign: 'left', 
              borderTop: `4px solid ${service.color}`, 
              display: 'flex', 
              flexDirection: 'column',
              justifyContent: 'space-between'
            }}
          >
            <div>
              {/* Cercle Icône avec SVG */}
              <div style={{ 
                width: '64px', 
                height: '64px', 
                borderRadius: '50%', 
                background: `${service.color}15`, // Transparence légère (15% hex)
                color: service.color, // L'icône SVG prend cette couleur (stroke="currentColor")
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center', 
                marginBottom: '24px',
                transition: 'transform 0.3s ease'
              }}>
                {service.icon}
              </div>

              <h3 style={{ marginBottom: '15px', fontSize: '1.3rem' }}>{service.title}</h3>
              
              <p style={{ 
                color: 'var(--text-grey)', 
                lineHeight: '1.7', 
                marginBottom: '25px',
                fontSize: '0.95rem'
              }}>
                {service.text}
              </p>
            </div>


          </div>
        ))}
      </div>

      {/* --- CTA Global --- */}
      <div style={{ textAlign: 'center', marginTop: '80px' }}>
        <p style={{ marginBottom: '25px', fontWeight: '500', fontSize: '1.1rem' }}>
          Vous avez un besoin spécifique qui n'est pas listé ici ?
        </p>
        <Link to="/contact" className="btn btn-primary">
          Discutons de votre vision
        </Link>
      </div>

    </div>
  );
}